"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Actions;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("../merch-button/button.js"));
var _buttonSet = _interopRequireDefault(require("../merch-button/button-set.js"));
var _index = _interopRequireDefault(require("../domain-search/index.js"));
var _index2 = _interopRequireDefault(require("../input-bar/index.js"));
var _index3 = _interopRequireDefault(require("../paragraph/index.js"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
const FormElementOverrides = "core-f13ucaui";
const ActionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ActionWrapper",
  class: "core-a1h184dg"
});
function Action({
  actionsLayout,
  templateMap,
  ctas
}) {
  const formCta = ctas[0];
  switch (actionsLayout) {
    case 'button-set':
      return /*#__PURE__*/_react.default.createElement(_buttonSet.default, {
        templateMap: templateMap,
        buttons: ctas
      });
    case 'input-bar':
      return /*#__PURE__*/_react.default.createElement(_index2.default, formCta);
    case 'domain-search':
      return /*#__PURE__*/_react.default.createElement(_index.default, formCta);
    case 'es-search':
      return formCta;
    case `none`:
    default:
      return null;
  }
}
Action.propTypes = {
  /**
   * Actions layout
   */
  actionsLayout: _propTypes.default.oneOf(['button-set', 'input-bar', 'domain-search', 'es-search', 'none']),
  /**
   * ctas array, e.g. NSMerchButton or InputBar.
   */
  ctas: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_button.default.propTypes), _propTypes.default.shape(_index2.default.propTypes), _propTypes.default.node])).isRequired,
  /**
   * Extra templates, to avoid circular dependencies,
   */
  templateMap: _propTypes.default.object
};

/**
 * Render Actions.
 *
 * @param {string} actionsLayout The actions layout to render
 * @param {array} ctas ctas array, supported types: NSMerchButton, AddToCartButton, VideoPlayButton, InputBar, and EPSearch.
 * @param {string} disclaimer Disclaimer text
 * @param {object} actionsTemplateMap Extra templates, to avoid circular dependencies
 * @returns {React.ReactElement} Actions
 * @public
 */
function Actions({
  actionsLayout = 'none',
  actionsTemplateMap,
  ctas,
  disclaimer
}) {
  if (ctas?.length === 0) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ActionWrapper, {
    className: actionsLayout === 'input-bar' ? FormElementOverrides : null
  }, /*#__PURE__*/_react.default.createElement(Action, {
    actionsLayout: actionsLayout,
    templateMap: actionsTemplateMap,
    ctas: ctas
  })), disclaimer && /*#__PURE__*/_react.default.createElement(_index3.default, {
    asType: "paragraph",
    size: -2,
    text: disclaimer
  }));
}
Actions.propTypes = {
  /**
   * Actions layout
   */
  actionsLayout: _propTypes.default.oneOf(['button-set', 'input-bar', 'domain-search', 'es-search', 'none']),
  ctas: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node])).isRequired,
  disclaimer: _propTypes.default.string,
  actionsTemplateMap: _propTypes.default.object
};